// Helpers for the "schedule post" feature. The compose state keeps the time as
// an ISO string (UTC); the datetime-local input works with local time.

const pad = (n) => String(n).padStart(2, "0");

export const isoToLocalInput = (iso) => {
  const d = new Date(iso);

  if (isNaN(d.getTime())) {
    return "";
  }

  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const localInputToIso = (value) => {
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d.toISOString();
};

// One hour from now, rounded up to the next 5 minutes.
export const defaultScheduledAt = () => {
  const d = new Date(Date.now() + 60 * 60 * 1000);
  d.setSeconds(0, 0);
  d.setMinutes(Math.ceil(d.getMinutes() / 5) * 5);
  return d.toISOString();
};
